export default __webpack_public_path__ + "static/media/cours.818e7b05.svg";